/**
 * Theme: single entry. useThemeColors(), appTheme, initializeTheme().
 */
import { useThemeStore } from './store';
import { initializeTheme, persistThemeAppearance } from './init';

export { useThemeStore } from './store';
export type { ThemeColors } from './store';
export {
  initializeTheme,
  refreshThemeForScheme,
  resolveThemeFromApi,
  persistThemeAppearance,
  resolveInitialThemeScheme,
  THEME_APPEARANCE_STORAGE_KEY,
} from './init';
export * from './colorUtils';
export { appTheme } from './appTheme';
export type { StackedRadialMenuShellStyles } from './sharedStyles';
export {
  sheetFormHeaderLogoSize,
  createBottomSheetChromeStyles,
  createCredentialFormSheetStyles,
  createRegistrationFormSheetStyles,
  createOtpCodeEntrySheetStyles,
  createPasswordRecoveryFormSheetStyles,
} from './authSheetStyles';
export type {
  BottomSheetChromeStyles,
  CredentialFormSheetStyles,
  RegistrationFormSheetStyles,
  OtpCodeEntrySheetStyles,
  PasswordRecoveryFormSheetStyles,
} from './authSheetStyles';

export const useThemeColors = () => useThemeStore(s => s.colors);

export { useScreenTheme } from './useScreenTheme';

export const ThemeService = {
  initialize: initializeTheme,
  persistAppearance: persistThemeAppearance,
};
